import { jurisdictionTimezone } from '@/data/data-selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const utcIANATimezone = 'Etc/UTC';

export function useTimezone() {
  const timeZone: string = useSelector(jurisdictionTimezone);

  const isValidIANATimezone = useMemo(() => {
    try {
      Intl.DateTimeFormat(undefined, { timeZone });
      return true;
    } catch (err) {
      return false;
    }
  }, [timeZone]);

  return isValidIANATimezone ? timeZone : utcIANATimezone;
}
